module.exports = __webpack_public_path__ + "static/media/logo7.3ecc08ca.png";